// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"482":"css/app.6963","4805":"css/admin-app.6963"}[chunkId] + ".css";
};